// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"6528a32e","149":"da7ec874","243":"0a0c2f6c","784":"651b5dff","794":"53bca043","841":"a7af9eab"}[chunkId] + ".chunk.css";
};